'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _model = require('../model');

var _model2 = _interopRequireDefault(_model);

var _gui = require('../gui');

var _gui2 = _interopRequireDefault(_gui);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Form).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'triggerUpdate',
    value: function triggerUpdate(meta, data, props, schema) {
      if (!schema) schema = _model2.default.process_schema(props.schema);
      var newMeta = _model2.default.generate_meta(meta, data, schema, props.validate);

      props.update && props.update(data, newMeta);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {

      // this means we are setting a new value and should trigger
      // an update once we have validated

      if (!nextProps.meta) {
        this.triggerUpdate(nextProps.meta, nextProps.data, nextProps);
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.props.meta) {
        this.triggerUpdate(this.props.meta, this.props.data, this.props);
      }
    }
  }, {
    key: 'render',
    value: function render() {

      var props = this.props;
      var self = this;

      var meta = JSON.parse(JSON.stringify(props.meta || {}));
      var data = JSON.parse(JSON.stringify(props.data || {}));

      if (!meta.fields) {
        meta.fields = {};
      }

      var schema = _model2.default.process_schema(props.schema);
      var formRenderer = _gui2.default.get_layout('form', props.layout);
      var rowRenderer = _gui2.default.get_layout('row', props.layout);

      function renderRow(field) {
        var fieldComponent = _gui2.default.get_library(field.type, props.library);
        var metaEntry = meta.fields[field.name] || {};

        var fieldElement = _react2.default.createElement(fieldComponent, {
          title: field.title,
          value: data[field.name],
          error: metaEntry.error,
          dirty: metaEntry.dirty,
          valid: metaEntry.valid,
          schema: field,
          update: function update(val) {

            data[field.name] = val;
            self.triggerUpdate(meta, data, props, schema);
          },
          blur: function blur() {

            var metaEntry = meta.fields[field.name];

            // only flag the field as dirty if it has changed
            // errors display if the field is dirty
            if (metaEntry && metaEntry.changed) {
              metaEntry.dirty = true;
            }

            meta.fields[field.name] = metaEntry;

            self.triggerUpdate(meta, data, props, schema);
          }
        });

        return _react2.default.createElement(rowRenderer, {
          title: field.title,
          field: field,
          key: 'field' + field.name
        }, fieldElement);
      }

      return _react2.default.createElement(formRenderer, {}, schema.map(renderRow));
    }
  }]);

  return Form;
}(_react.Component);

exports.default = Form;


/** WEBPACK FOOTER **
 ** ../biro/lib/components/Form.js
 **/